import type { CollectionSummary, SearchResult } from "./api/schemas";

export type ParsedSearch = { text: string; number: string | null };

/**
 * Only an explicit # marks a token number. Bare prices and names stay intact for backend search.
 * A dangling # is ignored (`Steam #` is just `Steam`).
 */
export function parseSearchQuery(raw: string): ParsedSearch {
  const query = raw.trim().replace(/\s+/g, " ");
  const token = /#\s*(\d+)$/.exec(query);
  if (token) return { text: query.slice(0, token.index).trim(), number: token[1] ?? null };
  return { text: query.replace(/#\s*$/, "").trim(), number: null };
}

/** Collections whose name contains the typed text (every word must appear, in any order). */
export function matchCollections(collections: readonly CollectionSummary[], text: string) {
  const words = text.toLowerCase().split(/\s+/).filter(Boolean);
  if (words.length === 0) return [];
  return collections.filter((item) => { const name = item.name.toLowerCase(); return words.every((word) => name.includes(word)); });
}

export function filterNumberSearchResults(results: SearchResult[], parsed: ParsedSearch) {
  if (parsed.number === null) return results;
  const number = parsed.number;
  const words = parsed.text.toLowerCase().split(/\s+/).filter(Boolean);
  return results.filter((nft) => String(nft.number).startsWith(number) &&
    words.every((word) => nft.collection_name.toLowerCase().includes(word)));
}
